import { createContext, useContext, useEffect, useState } from "react";
import { auth } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";
import { apiFetch } from "./api";
const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(undefined); // undefined = loading
    const [player, setPlayer] = useState(null);
    const [membership, setMembership] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
            setUser(firebaseUser || null);

            if (firebaseUser) {
                try {
                    await apiFetch("/auth/sync-player", {
                        method: "POST",
                    });

                    const playerRes = await apiFetch("/auth/player");
                    const player = await playerRes.json();

                    setPlayer(player || null);

                    if (player?.id && player?.leagues?.length > 0) {
                        const membershipRes = await apiFetch(`/league/${player.leagues[0]}/member/${player.id}`);
                        const membership = await membershipRes.json();
                        setMembership(membership || null);
                    }
                } catch (error) {
                    console.error("Failed to auth player", error);
                    setPlayer(null);
                }
            } else {
                setPlayer(null);
                setMembership(null);
            }

            setLoading(false);
        });

        return unsubscribe;
    }, []);



    return (
        <AuthContext.Provider
            value={{
                user,
                player,
                membership,
                loading
            }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}